import React from 'react'
import styled from 'styled-components'


const StyledDiv = styled.div`
    text-align: center;
    margin: auto;
    width: 100%;
`


function Diary({ content }) {

return (      
<div>
<br/>
 <br/>
 <StyledDiv>
 <img alt="" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/5bbf2533-1511-6c36-7dd2-c699eed83bf8.png" width="196" align="middle"/>    
<br/>        
<h3>the weather report 002</h3>
<small>9/1/23</small>
 </StyledDiv>
<p>
Hellooo weatherheads!!! Steve here again with the second edition of the approximately seasonal we broke the weather newsletter, the weather report. Got a few updates for yas…
<br/>
<br/>
Firstly we have a brand spanking new ~ b a n d c a m p  e x c l u s i v e ~ EP: Cabin Fever. Forged in the belly of the White Mountains. Fueled by hot dogs and cheap beers. We venture further into jam territory than ever before on this EP*. And also get synthy. Check it out <a href='https://webroketheweather.bandcamp.com/music' target="_blank">here</a>.
<br/>
<small>*Actually technically if you were at any of a certain set of four man wbtw shows last year, you might’ve seen us get this jammy</small>
<br/>
<br/>
Next up, in the heat of July, Fire Season came for WMBR. Specifically the show Pipeline! (Also, in breaking news, they rebroadcasted the show on my birthday—neat!)
<br/>
<br/>
<img height="105" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/9370eaac-dc81-6cd6-88c9-bf7d14659d27.png" width="266"/>
<br/>
<br/>
Now, as some of you may know, I’ll soon be the only kidless dad in wbtw. And for that reason we likely won’t playing shows again until well into 2024. But fear not, for my final piece of news for you weatherheads is that wbtw is bound for Kennedy Studios once again to track our second LP!!! Forged in the depths of Scott’s basement, honed on the killing fields of the small and medium small-ish stages in and around greater Boston, chock full of weird noises and songs and stuff… What else can I say? We’re pumped to cook up some new music for y’all!
<br/>
<br/>
<br/>
<br/>
On to Nick for some album recs:
</p>
<h2>feast your earholes</h2>
<i>wbtw’s Summer Jamz Playlist 2023</i>
<p>
<b>King Gizzard and the Lizard Wizard - <i>PetroDragonic Apocalypse etc. etc. etc.</i></b>
<img height="300" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/4f681a1c-fd26-627c-98fb-7ed0e20d0abf.jpg" width="300"/>

<br/>
<br/>
Oh wow, what a surprise, we broke the weather likes Gizzard. Okay, but seriously, this goddamn album. I still don’t know how they did it, but somehow Gizz managed to write the gnarliest, most technically and cognitively-demanding shit and make it sound like the soundtrack to a mosh pit at Hellfest. When people say that the goal of complex music is to make it sound simple, this is what they’re talking about. They’ve been elevating their game for a while now, but they basically went into god mode for this one. We’re truly not worthy.
<br/>
<br/>
</p>
<p>
  <b>Astroverse Dimensions - <i>Feeding on the Spirit</i></b>
  <img height="300" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/535716be-ab08-6b37-02fe-681bce4281d6.jpg" width="300"/>

  <br/>
  Okay, stick with me here. Remember that Smashmouth album Astro Lounge, with the terrible/amazing artwork that can only be described as late 90s future-core (everything was very shiny and poorly-rendered)? I’m pretty sure this is the album that would actually be played in said Astro Lounge. It’s got some synthy pastiche to it, distorted voiceovers and all, and it heavily features some kind of theremin patch for extra spook. But it also grooves like a motherfucker and makes me want to dance around like an idiot. The riffs are great too, if that’s your thing (if you’re reading this and follow us it should be your thing).
  <br/>
  <br/>
</p>

<p>
  <b>Scaphoid - <i>Echoes of the Rift</i></b>
  <img height="300" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/d23126ae-42d6-d4f5-08f1-6d665c80d251.jpg" width="300"/>

  <br/>
  Speaking of riffs, this album is basically just one giant riff. Echoes of the Rift is 45 minutes of immaculately-composed instrumental progressive rock/metal. This one is for the adventurer who wants to be aurally bludgeoned in the face by the sheer epicness of their journey. I guarantee you will want to scale some mountain or conquer some shit (metaphorically or literally) upon listening to this album.
  <br/>
  <br/>
</p>

<p>
  <b>Reformat - <i>Precursed</i></b>
  <img height="272" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/540bd55d-b2ac-0afc-3932-fa567dda83d1.jpg" width="300"/>

  <br/>
  Okay, I got one more high-octane pick for you all. There’s a specific brand of instrumental post-rock that I can’t get enough of that consists of screeching synths, electronic elements, futuristic themes and visions, and energy out the wazoo. 65daysofstatic are pretty much the standard-bearer for this niche, with a bunch of other incredible bands filling in the space around them, some darker (pg.lost, Barrens), and some lighter (Three Trapped Tigers). Reformat are in the latter category, taking a somewhat tongue-in-cheek approach to their work of composing gigantic robot apocalypse parties. Their previous effort was really good. This one is incredible. Just front to back heartstopping action. If anything could motivate me to run long distances in the heat, it would be this album.
  <br/>
  <br/>

</p>
<br/>
<hr class="rounded"></hr> 

<h3>and now, this</h3>
<br/>
<img data-file-id="2508654" height="400" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/cd1ab65f-a733-3412-e54f-5128c20ebe8d.jpg" width="300"/>
<br/>
<p>And finally, to Restart our approximately seasonal we broke the weather newsletter baseball commentary section, here’s Kev:</p>
<br/>
<p>
Bottom of the 9th. Bases loaded. No outs. Disaster lurking around the corner. You’re on your couch, an utterly useless contribution to the tension illuminating from the screen. Hope is still an option. Until swiftly, it’s not. Pitch, swing, wack. The nearly inevitable predictably succumbs. Game over. You release an audible sigh and prepare to dream. Maybe they’ll win tomorrow’s Game.
</p>
<hr class="rounded"></hr> 
<br/>
<br/>
<br/>

<StyledDiv>
<img alt="" src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/5bbf2533-1511-6c36-7dd2-c699eed83bf8.png" width="196" align="middle"/>    
<br/>        
<h3>the weather report</h3>
<small>4/7/23</small>
</StyledDiv>             
<p>
Hellooo weatherheads!!! Welcome to the inaugural w e a t h e r  r e p o r t, a friendly little newsletter for keeping our buds and pals up to date on all things we broke the weather.
<br/>
<br/>

2022 was an exciting year for us. We released our debut album to critical acclaim (which we’re still floored by tbh), released a live-in-the-studio EP (along with some sick headless kev vids), and even got nominated for Boston Music Awards’ Jazz Artist of the Year–which is pretty neat. Best of all though, we got to stay up late and play some rock n roll for you, our fans and buds and pals. Words cannot describe our appreciation for y’all showing up for our string of late nite weeknight dive bar sets. It really means the world to us.
<br/>
<br/>
We’re moving on up in 2023, comin at ya with weekend shows at potentially more reasonable hours. Next up:
<br/>
<br/>

<img src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/1d17a463-decd-421f-63e4-4952eb45ada9.png"  width="271" height="420"/>

<br/>
<br/>
<a href="https://lunalowell.com/movies/sons-lunaris-rumboat-chili-we-broke-the-weather-4-8-630/" >4/8 with Sons Lunaris and Rumboat Chili @ The Overlook in Lowell, MA</a>
<br/>
<br/>
<a href="https://eventbrite.com/e/free-rock-the-cosmic-vultures-renee-maskin-tickets-593430676127" target="_blank">5/6 with Free Rock, Cosmic Vultures, and Renee Maskin&nbsp;@ The Jungle in Somerville MA</a>
<br/>
<br/>

With more to come. We'll keep you posted here and at webroketheweather.com as shows crop up. <br/>
Sadly, due to a scheduling conflict, we will not be playing Somerville Porchfest this year :(
<br/>
<br/>

But rest assured, while we aren't on stage actively trying to decapitate you with sound, we’re also hard at work on new material, upgrading the practice space, cooking up demos, messin around with synths, revamping the live setup, etc etc 
 <br/>
 <br/>

- Steve
</p>

<hr class="rounded"></hr> 

<h3>feast your earholes</h3>
<h4>Nick's Picks</h4>
<img src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/7af92216-5442-4616-ea60-ca815c0dc30b.jpg"   width="100%" ></img>
<br/>
<p>
<a href="https://aimingforenrike.bandcamp.com/album/empty-airports" target="_blank"  >Aiming For Enrike - Empty Airports</a> <b>(electronic, minimalism, math rock)</b>
<br/>
<br/>

  The first time I saw Norway’s Aiming For Enrike was opening for fellow Norwegian jazz-rock juggernauts Jaga Jazzist in I think 2016 or ‘17. Back then the duo were more solidly in the playful/driving instrumental math rock space – think Battles, And So I Watch You From Afar, VASA, etc. I’ve loosely kept tabs on them since, but Empty Airports has caught my attention in a way they hadn’t before. Something about the mixture of smooth synths on top of their more typical guitar loops and themes just does something to me. Feels like a synthwave-y, cyberpunk-y beach party at sunset. Basically the vibes are immaculate.      
</p>    
<br/>

<img src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/7c9fd555-42c3-49fc-0626-071e08768372.jpg"   width="100%"></img>
<br/>
<br/>

<a href="https://atsukochiba.bandcamp.com/album/water-it-feels-like-its-growing" target="_blank"  >Atsuko Chiba - Water, It Feels Like It’s Growing</a> <b>(prog psych rock)</b>   
<p>
Montreal’s Atsuko Chiba have made a point of being near impossible to define, but whatever they’ve thrown out there has been both fascinating and an utter joy to listen to. Their winning streak continues on their latest, which I can basically describe as the psychedelic grooviness of Gizzard but just the more experimental parts and also after having taken an edible. Once again, vibes up the wazoo. Take me up to space and let me float amongst the stars to this shit.
</p>
<img src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/9c4eb1fb-f7f4-89f4-d1a5-a6268cbfee84.jpg"    width="100%"></img>
<br/>
<br/>

<a href="https://witchripper.bandcamp.com/album/the-flight-after-the-fall-2" target="_blank"  >Witch Ripper - The Flight After the Fall</a> <b>(prog stoner metal)</b>
 <p>
 One of the qualities that pretty much without fail will make me love a piece of music is if I think to myself, “This shit sounds like Mastodon’s Blood Mountain!” If that doesn’t automatically conjure up a very specific image to you, then basically imagine music with big-ass riffs, big-ass melodies, and big-ass fuzz that straddles the line between being nerd shit and music to slam beer cans on your forehead to. There’s definitely some touches of more Mars Volta, Rush, The Dear Hunter, what-have-you kind of capital P prog as well if you’re into that (and if you’re reading this, I’m going on a hunch that you probably are).
 </p>    
<br/>
 <h4>Steve's sleeve</h4>
 <img src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/34249729-91a1-bf52-6534-dbf28e744eef.jpg"   width="100%"></img>
 <br/>
 <br/>

 <a href="https://delugegrander.bandcamp.com/album/oceanarium-2" target="_blank"  >Deluge Grander - Oceanarium</a> <b>(instrumental prog)</b>
<p>
Slip into your wizard robes, pack yourself a bowl of halflings leaf, and whisper some forbidden incantations because this is a straight up instrumental prog banger. This 2017 offering from Dan Britton’s Deluge Grander feels very much like an extension of his work in Birds and Buildings—which I typically describe as early King Crimson crossed with fusion era Zappa—only with more over the top instrumentation and somehow even more thematic composition. If you’re looking to score your next D&D campaign and/or just looking to escape to the shadow realm for an hour and change, look no further. 
</p>
<br/>
<hr class="rounded"></hr> 

<h3>and now, this</h3>
<br/>
<img src="https://mcusercontent.com/65c5bfbaf87d036d0dd3dcacc/images/b2cdcf9a-5bd3-625f-c078-0524bc32a08d.jpg"    width="100%"></img>
<br/>
<h4>art, ai, baseball</h4>
<p>
Remember Moneyball? Does the name ‘Brad Pitt’ ring a bell? For those who don’t follow America’s pastime or watch B Pitt movies, the game of baseball fell victim to data and algorithms long before your new chatbot friend arrived into this mess of a reality. As the story goes, Brad and Jonah’s ideas led to more analytics-based strategies, and the blueprints of baseball were handed over to our ruthless robot overlords. For the first time ever, there was an unforeseen consequence of technology. (@Andy pls fact check this)
<br/>
<br/>
Many argue that the robots made an already slow-paced game more predictable, uninspired, and some (not me) even say - boring. It certainly didn’t make it easier for an old, slow game to compete with instagram for our beloved humanity’s attention. Thanks, Brad.
<br/>
<br/>
I’m not saying the new rules of baseball are going to cure your TikTok addiction. You’re gonna need much harder drugs for that. I’m suggesting that the most interesting ideas behind the rule changes are the attempts to dampen the soulless reverberations AI has injected into the game. We’re witnessing a human effort to make baseball more exciting, interesting, and weird. A slight shift to shake things up.
<br/>
<br/>
If you didn’t like baseball before, you most likely still won’t. If you like baseball, you probably have a lot to say about all this. If you like chatting with bots and gazing longingly into the Eye of AI art, cool. At any rate, I think the lessons baseball offers us are at least worth thinking about. This one sure seems timely.
<br/>
<br/>
Love,<br/>
Kev 
</p>
</div>
)
}

export default Diary
